import axios from 'axios';
import { setPreferredNotifyChannel } from './notifyChannel';

const SMS_KEY = 'notifySmsEnabled';
const WHATSAPP_KEY = 'notifyWhatsappEnabled';

export const DEFAULT_NOTIFICATION_PREFERENCES = {
  sms: false,
  whatsapp: true,
  email: true,
  push: true,
};

export function normalizeNotificationPreferences(prefs) {
  const source = prefs && typeof prefs === 'object' ? prefs : {};
  return {
    sms: source.sms === true,
    whatsapp: source.whatsapp !== false,
    email: source.email !== false,
    push: source.push !== false,
  };
}

/** Keep order/OTP channel selection aligned with saved prefs. */
export function syncNotificationPreferencesFromProfile(prefs) {
  const normalized = normalizeNotificationPreferences(prefs);
  try {
    localStorage.setItem(SMS_KEY, String(normalized.sms));
    localStorage.setItem(WHATSAPP_KEY, String(normalized.whatsapp));
    if (normalized.whatsapp) {
      setPreferredNotifyChannel('whatsapp');
    } else if (normalized.sms) {
      setPreferredNotifyChannel('sms');
    }
  } catch (_e) {
    /* private mode */
  }
  return normalized;
}

export function readCachedNotificationPreferences() {
  try {
    const sms = localStorage.getItem(SMS_KEY);
    const whatsapp = localStorage.getItem(WHATSAPP_KEY);
    if (sms === null && whatsapp === null) return null;
    return normalizeNotificationPreferences({
      sms: sms === 'true',
      whatsapp: whatsapp !== 'false',
    });
  } catch (_e) {
    return null;
  }
}

export async function updateNotificationPreferences(partialPrefs) {
  const { data } = await axios.put('/users/profile', {
    notificationPreferences: partialPrefs,
  });
  const fromProfile = data?.data?.notificationPreferences;
  if (fromProfile) {
    return syncNotificationPreferencesFromProfile(fromProfile);
  }
  const merged = normalizeNotificationPreferences({
    ...DEFAULT_NOTIFICATION_PREFERENCES,
    ...readCachedNotificationPreferences(),
    ...partialPrefs,
  });
  syncNotificationPreferencesFromProfile(merged);
  return merged;
}
